import React from 'react';
import PropTypes from 'prop-types';
import ConnectedUploadForm from './ConnectedUploadForm';

const UploadRouting = ({ match }) => <ConnectedUploadForm />;

UploadRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default UploadRouting;
